let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ZxcX")).then(() => parcelRequire('39yQy'));